module.exports = __webpack_public_path__ + "img/land-valuation.18d34b95.jpeg";